<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
import types from '@/utils/types'
import titleSlug from '@/helpers/titleSlug'
import { EventBus } from '@/plugins/event-bus'

export default {
  async fetch({ params, store, $asa }) {
    try {
      await store.dispatch('photos/resetPhoto')
      const id = params.id
      await store.dispatch('photos/getOne', {
        id
      })
    } catch (error) {
      $asa.appInsights('Pages: photo/_id/index.vue - method: fetch', error)
    }
  },
  head({ $seo }) {
    return $seo({
      title: this.photoTitle,
      description: `Enjoy ${this.photo.title} by ${this.photo.photographerName}, one of the best images by 100ASA's community.`,
      url: `https://100asa.com/photo/${this.photo.id}/${this.photo.slug}`,
      image: {
        url: this.photo.thumbnailUrl,
        width: this.photo.width,
        height: this.photo.height
      }
    })
  },
  computed: {
    ...mapState({
      photo: state => state.photos.photo
    }),
    photoTitle() {
      let photoTitle = ''
      if (this.photo.statusName !== types.photo.status.inCuration) {
        photoTitle = `${this.photo.title}`
      } else {
        photoTitle = `${this.photo.title} by ${this.photo.photographerName}`
      }
      return photoTitle
    }
  },
  mounted() {
    if (this.photo && this.photo.id === parseInt(this.$route.params.id)) {
      this.redirect()
    } else {
      this.$router.replace('/login')
    }
  },
  methods: {
    redirect() {
      let query = ''
      const comment = this.$route.query.comment
      if (comment) {
        query += `?comment=${comment}`
      }
      try {
        const id = this.$route.params.id
        const slug = titleSlug(this.photo.title)
        this.$router.replace(`/photo/${id}/${slug}${query}`)
      } catch (error) {
        EventBus.$emit('snackbar', {
          text: 'Photo not found or not longer available on 100ASA',
          color: 'error'
        })
      }
    }
  }
}
</script>
